module.exports = __webpack_public_path__ + "static/img/tow.dd16bb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gRDImg/tow.png
// module id = bwIa
// module chunks = 1